import React, { useContext, useEffect, useState } from "react";
import "./index.scss";
import { useParams } from "react-router-dom";
import { getListOfOrdersByPagination } from "../../services/get-orders-by-pagination";
import { toast } from "react-toastify";
import Modal from "react-modal";

import ModalOrderDetail from "../ModalOrderDetail";
import { updateOrderStatus } from "../../services/update-order-status";
import { UserContext } from "../context/userContext";

const OrderStatusDropdown = ({
  currentStatus,
  onUpdateStatus = (arg1: any, arg2: any) => {},
  orderId,
}) => {
  const [status, setStatus] = useState(currentStatus);

  const handleChange = (e: any) => {
    e.stopPropagation();
    const newStatus = e.target.value;
    setStatus(newStatus);
    onUpdateStatus(newStatus, orderId);
  };

return (
  <select value={status} onChange={handleChange} className="status-select">
    <option value="Not processed">Not processed</option>
    <option value="Processing">Processing</option>
    <option value="Shipped">Shipped</option>
    <option value="Delivered">Delivered</option>
    <option value="Cancelled">Cancelled</option>
  </select>
);

};
const customStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)", // Change the background color and opacity here
  },
  content: {
    top: "40%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    height: "65vh",
    minHeight: "65vh",
    borderWidth: 0.2,
    borderRadius: 12,

    background: "#fff",
  },
};
function ListOrders() {
  const { user } = useContext(UserContext);

  const [listOfOrders, setListOfOrders] = useState<any[]>([]);

  const [limit, setLimit] = useState<number>(10);
  const [page, setPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [loading, setLoading] = useState(false);
  const { storeId } = useParams();
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const closeModal = () => {
    setIsOpen(false);
  };
  const doGetTransactionsHistoryByProduct = () => {
    setLoading(true);
    getListOfOrdersByPagination(page, limit)
      .then((response) => {
        setLoading(false);

        if (response?.status === 500) {
          toast.error("Internal server error !");
          return;
        }
        if (!response?.success) {
          toast.error(response?.message);
          return;
        }
        if (response?.success) {
          setListOfOrders(response?.content?.orders);
          setTotalPages(response?.content?.totalPages);
        }
      })
      .catch((error) => {
        setLoading(false);

        toast.error(error);
      });
  };

  function formatDate(inputDate: any) {
    const date = new Date(inputDate);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-based
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }
  useEffect(() => {
    doGetTransactionsHistoryByProduct();
  }, [page]);

  const changePage = (newPage: any) => {
    setPage(newPage);
  };

  const openDetail = (order: any) => {
    setIsOpen(true);
    setSelectedOrder(order);
  };

  const onUpdateStatus = async (newStatus: any, orderId: any) => {
    const data = { newStatus: newStatus };
    let token = await localStorage.getItem("token");

    updateOrderStatus(data, orderId, user?._id, token)
      .then((response) => {
        if (response?.status === 500) {
          toast.error("Internal server error !");
          return;
        }
        if (!response?.success) {
          toast.error(response?.message);
          return;
        }
        if (response?.success) {
          toast.success("status updated !");
        }
      })
      .catch((error) => {
        toast.error(error);
      });
    // Send updateOrderStatus request with the new status
    // You should implement the updateOrderStatus function according to your requirements
  };

  return (
    <div className="orders-list">
      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Order number</th>
              <th>Client</th>
              <th>Date de réception</th>
              <th className="cell-center">Details</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={5} className="admin-loading-row">
                  Loading orders…
                </td>
              </tr>
            ) : listOfOrders?.length > 0 ? (
              listOfOrders.map((order: any, index: any) => (
                <tr key={order?._id || index}>
                  <td>{order?.transaction_id}</td>
                  <td>{order?.user?.name}</td>
                  <td>{formatDate(order?.createdAt)}</td>
                  <td className="cell-center">
                    <button
                      className="row-icon-btn"
                      title="View details"
                      onClick={(e) => {
                        e.stopPropagation();
                        openDetail(order);
                      }}
                    >
                      <i className="bx bxs-file-find"></i>
                    </button>
                  </td>
                  <td>
                    <OrderStatusDropdown
                      currentStatus={order?.status}
                      onUpdateStatus={onUpdateStatus}
                      orderId={order?._id}
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} className="admin-empty-row">
                  No orders yet
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <button onClick={() => changePage(page - 1)} disabled={page === 1}>
          ◀ Prev
        </button>
        <span>
          Page {page} / {totalPages}
        </span>
        <button
          onClick={() => changePage(page + 1)}
          disabled={page === totalPages}
        >
          Next ▶
        </button>
      </div>

      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
        ariaHideApp={false}
      >
        <ModalOrderDetail order={selectedOrder} closeModal={closeModal} />
      </Modal>
    </div>
  );
}

export default ListOrders;
